import { IBiddingDetailResponse } from "../../../model/base/response/bidding-detail-response";

export enum ACTION_TYPES {
    SET_BIDDING_DETAIL = 'SET_BIDDING_DETAIL'
}

export interface IBiddingDetailState {
    biddingDetail: IBiddingDetailResponse | null;
}

export const initialState: IBiddingDetailState = {
    biddingDetail: null
};

export type Action =
    | { type: ACTION_TYPES.SET_BIDDING_DETAIL; payload: IBiddingDetailResponse };

export const biddingDetailReducer = (state: IBiddingDetailState, action: Action): IBiddingDetailState => {
    switch (action.type) {
        case ACTION_TYPES.SET_BIDDING_DETAIL:
            return { ...state, biddingDetail: action.payload };
        default:
            throw new Error(`Unhandled action type`);
    }
};
